import { Button, Checkbox } from 'antd';
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { useRootData } from 'hooks/hook';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { IGridStore } from '../../../../stores/GridStore';
import { EssityColumnProps } from '../GridHelper';
import { CenteredRow } from 'layout/CenteredRow';

interface IProps<T> {
	column: EssityColumnProps<T>;
	handleSearch: (value?: boolean) => void;
	gridName: string;
	filterProps: FilterDropdownProps;
}

const GridFilterCheckbox = <T extends any>(props: IProps<T>) => {
	const { column, handleSearch, gridName, filterProps } = props;

	const [checked, setChecked] = useState<boolean>(false);
	const gridStore: IGridStore = useRootData((store) => store.gridStore);

	useEffect(() => {
		const columnFilter = gridStore.getColumnFilter(gridName, column.key!)?.value;
		setChecked(columnFilter === 'true');
	}, []);

	useEffect(() => {
		if (!filterProps.visible) {
			filterProps.confirm?.();
		}
	}, [filterProps.visible]);

	const handleChange = (e: any) => {
		const isChecked = e.target.checked;
		setChecked(isChecked);
	};

	const search = () => {
		gridStore.saveColumnFilter(gridName, column.key!, checked.toString());
		handleSearch(checked);
		filterProps.confirm?.();
	};

	const clear = () => {
		setChecked(false);
		gridStore.clearColumnFilter(gridName, column.key!);
		handleSearch(undefined);
		filterProps.confirm?.();
	};

	return (
		<div className="filter-block" style={{ padding: 8 }}>
			<CenteredRow>
				<Button
					aria-label="Search"
					type="primary"
					icon={<SearchOutlined />}
					size="small"
					onClick={search}
				>
					Search
				</Button>
				<Button
					aria-label="Clear"
					size="small"
					style={{ marginLeft: 4 }}
					icon={<DeleteOutlined />}
					onClick={clear}
				>
					Clear
				</Button>
			</CenteredRow>
			<Checkbox
				checked={checked}
				onChange={handleChange}
				style={{ padding: '8px', marginTop: '8px' }}
			>
				{column.title}
			</Checkbox>
		</div>
	);
};

export default observer(GridFilterCheckbox);
